window.bcl = window.bcl || {};
window.bcl.u = window.bcl.u || {};

const DOC = document;
const DOC_EL = DOC.documentElement;
const HEAD = DOC.head || DOC.getElementsByTagName("head")[0];
const WIN = window;
const LOC = WIN.location;
const ORIGIN = LOC.origin;
const crossOriginURLS = /booking.barcelo.com|reservation.barcelo.com/;
WIN.crossOriginURLS = WIN.crossOriginURLS || crossOriginURLS;

const utils = WIN.bcl.u;
utils.loadedStylesKeys = utils.loadedStylesKeys || new Set();
utils._cssPromises = utils._cssPromises || new Map();

const AEM_FINGERPRINT_RE = /\.lc-[^-]+-lc(\.min)?\.css$/i;
const ABSOLUTE_RE = /^(?:[a-z][a-z0-9+.-]*:)?\/\//i;
const normCache = new Map();
const linkByBaseKey = new Map();
const afterLoadCallbacks = new Map();

const enqueueAfterLoad = (key, fn) => {
  let arr = afterLoadCallbacks.get(key);
  if (!arr) {
    arr = [];
    afterLoadCallbacks.set(key, arr);
  }
  arr.push(fn);
};

const flushAfterLoad = (key) => {
  const arr = afterLoadCallbacks.get(key);
  if (!arr || !arr.length) {
    return;
  }
  for (let i = 0; i < arr.length; i++) {
    try {
      arr[i]();
    } catch (error) {
      console.error("Callback in flushAfterLoad failed:", error);
    }
  }
  afterLoadCallbacks.delete(key);
};

const makeFallbacks = function (sel) {
  if (!sel) return [];
  const m = sel.match(/\.([A-Za-z0-9_-]+)/);
  const base = m ? `.${m[1]}` : sel;
  return [sel, `${base}.hiddenComponent`, `${base}.dynamicLoading`, base];
};

const getNormalizedCssKey = function (href) {
  if (!href) return "";
  const cached = normCache.get(href);
  if (cached) return cached;
  let path = href;
  try {
    path = new URL(href, ORIGIN).pathname;
  } catch {
    path = href.split("#")[0].split("?")[0];
    if (path[0] !== "/") path = "/" + path;
  }
  const key = path.replace(AEM_FINGERPRINT_RE, ".css").replace(/\.min\.css$/i, ".css");
  normCache.set(href, key);
  return key;
};

const findStyleLinkByBaseKey = function (baseKey) {
  let link = linkByBaseKey.get(baseKey);
  if (link && link.isConnected) return link;
  if (link) linkByBaseKey.delete(baseKey);

  const links = Array.from(DOC.querySelectorAll("link[rel='stylesheet'], link[rel='preload'][as='style']"));
  for (const l of links) {
    if (l.dataset.basekey === baseKey) {
      linkByBaseKey.set(baseKey, l);
      return l;
    }
    if (getNormalizedCssKey(l.href) === baseKey) {
      l.dataset.basekey = baseKey;
      linkByBaseKey.set(baseKey, l);
      return l;
    }
  }
  return null;
};

const toAbsoluteBarceloUrl = function (href) {
  if (ABSOLUTE_RE.test(href)) return href;
  const isCross = typeof WIN.crossOriginURLS !== "undefined" && WIN.crossOriginURLS.test(LOC.hostname);
  if (isCross) {
    return href.startsWith("/") ? `https://www.barcelo.com${href}` : `https://www.barcelo.com/${href}`;
  }
  return href;
};

const removeSelectorClasses = function (el, classSelector, keepClasses) {
  if (!el || !el.classList || !classSelector) {
    return;
  }

  const keep = Array.isArray(keepClasses) && keepClasses.length ? keepClasses : ["dynamicLoading"];
  const re = /\.([A-Za-z0-9_-]+)/g;
  let m;
  while ((m = re.exec(classSelector))) {
    const cls = m[1];
    let shouldKeep = false;
    for (let i = 0; i < keep.length; i++) {
      if (keep[i] === cls) {
        shouldKeep = true;
        break;
      }
    }
    if (!shouldKeep && el.classList.contains(cls)) {
      el.classList.remove(cls);
    }
  }
};

const runSwapFor = function ({ classSelector, removeSelector, keepClasses, baseKey, emitEventOnLoad }) {
  const applySwap = function () {
    if (!classSelector) {
      return true;
    }

    let els = null;
    const candidates = makeFallbacks(classSelector);

    for (let i = 0; i < candidates.length; i++) {
      const nodeList = DOC.querySelectorAll(candidates[i]);
      if (nodeList && nodeList.length) {
        els = nodeList;
        break;
      }
    }

    if (!els || !els.length) {
      return false;
    }

    for (let i = 0; i < els.length; i++) {
      const el = els[i];

      if (removeSelector === true) {
        removeSelectorClasses(el, classSelector, keepClasses);
      } else if (typeof removeSelector === "string" && typeof el.classList === "object") {
        el.classList.remove(removeSelector.replace(".", ""));
      }

      const loaders = el.querySelectorAll(".component-loader");
      for (let j = 0; j < loaders.length; j++) {
        const n = loaders[j];
        const owner = n.closest(".dynamicLoading");
        if (!owner || owner === el) {
          n.remove();
        }
      }

      const cl = el.classList;
      if (cl && cl.replace) {
        cl.replace("hiddenComponent", "visibleComponent");
      } else {
        if (cl && cl.contains("hiddenComponent")) {
          cl.remove("hiddenComponent");
        }
        cl && cl.add("visibleComponent");
      }

      if (!keepClasses && cl && cl.contains("dynamicLoading") && !cl.contains("c-fastbooking")) {
        setTimeout(() => cl.remove("dynamicLoading"), 600);
      }
    }

    return true;
  };

  const safeReveal = function (frames) {
    frames = frames == null ? 2 : frames;

    if (frames > 0) {
      WIN.requestAnimationFrame(() => safeReveal(frames - 1));
      return;
    }

    if (!applySwap()) {
      const delays = [0, 50, 150, 400, 1000];
      let idx = 0;

      const tick = function () {
        if (applySwap()) {
          return;
        }
        if (idx < delays.length) {
          setTimeout(tick, delays[idx++]);
        }
      };

      WIN.requestAnimationFrame(tick);

      let mo;
      const stop = function () {
        try {
          mo && mo.disconnect();
        } catch (error) {
          console.error("MutationObserver disconnect failed:", error);
        }
        mo = null;
      };

      try {
        mo = new MutationObserver(function () {
          if (applySwap()) {
            stop();
          }
        });
        mo.observe(DOC_EL, { childList: true, subtree: true });
        setTimeout(stop, 2500);
      } catch (error) {
        console.error("MutationObserver setup failed in safeReveal:", error);
      }
    }
  };

  safeReveal();

  if (emitEventOnLoad) {
    try {
      DOC.dispatchEvent(new CustomEvent("stylesLoaded_" + classSelector));
      DOC.dispatchEvent(new CustomEvent("stylesLoaded", { detail: { key: baseKey, selector: classSelector } }));
    } catch (error) {
      console.error("Failed to dispatch stylesLoaded event:", error);
    }
  }
};

bcl.u.loadStyleSheet = function (src, classSelector, emitEventOnLoad, removeSelector, keepClasses, waitFor) {
  if (!src) {
    return Promise.resolve();
  }

  const baseKey = getNormalizedCssKey(src);

  enqueueAfterLoad(baseKey, () => runSwapFor({ classSelector, removeSelector, keepClasses, baseKey, emitEventOnLoad }));

  if (utils._cssPromises.has(baseKey)) {
    return utils._cssPromises.get(baseKey);
  }

  const promise = new Promise(function (resolve) {
    const longCacheKey = typeof utils.getLongCacheKey === "function" && utils.getLongCacheKey();
    let finalHref = longCacheKey ? src.replace(".css", `.lc-${longCacheKey}-lc.min.css`) : src;

    if (typeof WIN.crossOriginURLS !== "undefined" && WIN.crossOriginURLS.test(LOC.hostname)) {
      finalHref = toAbsoluteBarceloUrl(finalHref);
    }

    let completed = false;
    let didInjectStylesheet = false;

    const completeLoad = function () {
      try {
        flushAfterLoad(baseKey);
      } catch (error) {
        console.error("[loadStyleSheet] Error flushing afterLoad callbacks:", error);
      }
      resolve();
    };

    const finishOnce = function () {
      if (completed) {
        return;
      }
      completed = true;

      if (!waitFor) {
        completeLoad();
        return;
      }

      Promise.resolve(waitFor).then(completeLoad, function (error) {
        console.error("[loadStyleSheet] Error waiting for dependent styles:", error);
        completeLoad();
      });
    };

    const finishWhenStylesheetReady = function (link) {
      if (link.sheet) {
        finishOnce();
        return;
      }

      link.addEventListener("load", finishOnce, { once: true });
      link.addEventListener("error", finishOnce, { once: true });

      setTimeout(function () {
        if (completed) {
          return;
        }
        if (link.sheet) {
          finishOnce();
        } else {
          setTimeout(finishOnce, 5000);
        }
      }, 3000);
    };

    let existingLink = findStyleLinkByBaseKey(baseKey);
    if (existingLink && existingLink.rel === "stylesheet") {
      utils.loadedStylesKeys.add(baseKey);
      return finishWhenStylesheetReady(existingLink);
    }

    WIN.requestAnimationFrame(function () {
      existingLink = findStyleLinkByBaseKey(baseKey);
      if (existingLink && existingLink.rel === "stylesheet") {
        utils.loadedStylesKeys.add(baseKey);
        return finishWhenStylesheetReady(existingLink);
      }

      utils.loadedStylesKeys.add(baseKey);

      let isCross = false;
      try {
        isCross = new URL(finalHref, ORIGIN).origin !== ORIGIN;
      } catch {
        isCross = false;
      }

      const styleFetchPriority = "auto";

      const promotePreloadToStylesheet = function (link) {
        link.rel = "stylesheet";
        link.media = "all";
        finishWhenStylesheetReady(link);
      };

      if (existingLink && existingLink.rel === "preload" && existingLink.as === "style") {
        return promotePreloadToStylesheet(existingLink);
      }

      const injectStylesheet = function () {
        if (completed || didInjectStylesheet) return;
        didInjectStylesheet = true;
        const styleLink = DOC.createElement("link");
        styleLink.rel = "stylesheet";
        styleLink.href = finalHref;
        styleLink.media = "all";
        if (isCross) styleLink.crossOrigin = "anonymous";
        styleLink.dataset.basekey = baseKey;
        linkByBaseKey.set(baseKey, styleLink);

        finishWhenStylesheetReady(styleLink);
        HEAD.appendChild(styleLink);
      };

      const preload = DOC.createElement("link");
      preload.rel = "preload";
      preload.as = "style";
      preload.href = finalHref;
      preload.setAttribute("importance", styleFetchPriority);
      preload.fetchPriority = styleFetchPriority;
      preload.setAttribute("data-basekey", baseKey);
      linkByBaseKey.set(baseKey, preload);

      if (isCross) preload.crossOrigin = "anonymous";

      preload.onload = function () {
        try {
          preload.remove();
        } catch {}
        injectStylesheet();
      };

      preload.onerror = function () {
        try {
          preload.remove();
        } catch {}
        injectStylesheet();
      };

      const PRELOAD_TIMEOUT_MS = 3000;
      setTimeout(function () {
        if (!completed) injectStylesheet();
      }, PRELOAD_TIMEOUT_MS);

      HEAD.appendChild(preload);
    });
  });

  utils._cssPromises.set(baseKey, promise);
  promise.finally(function () {
    utils._cssPromises.delete(baseKey);
  });
  return promise;
};
